import React from 'react';
import { ExclamationCircleFill } from 'styled-icons/bootstrap';
import styled, { ThemeContext } from 'styled-components';
import { motion } from 'framer-motion';
import { Cross } from 'styled-icons/entypo';
import { NotificationType, UserNotification } from '../../hooks/useNotifications/UserNotification';
import { UnstyledButton } from '../../modules/lower-ui-kit';

export type ToasterProps = {
  onClear: () => void;
} & UserNotification;

function Toaster({
  title, message, notificationType, onClear,
}: React.PropsWithoutRef<ToasterProps>) {
  const theme = React.useContext(ThemeContext);

  return (
    <Container>
      <Content
        style={{
          backgroundColor: notificationType === NotificationType.Info
            ? theme.colors.info
            : theme.colors.error,
        }}
        animate={{
          opacity: 1,
          y: -50,
        }}
        initial={{
          opacity: 0,
          y: 0,
        }}
        transition={{
          duration: 0.3,
          ease: 'easeIn',
        }}
      >
        <ExclamationCircleFillIcon
          color={'#ffff'}
          size={35}
        />
        <NotificationDiv>
          <Title>
            {title}
          </Title>
          <Message>
            {message}
          </Message>
        </NotificationDiv>

        <CloseButton onClick={onClear}>
          <StyledCross size={20} />
        </CloseButton>
      </Content>
    </Container>
  );
}

export default Toaster;

const ExclamationCircleFillIcon = styled(ExclamationCircleFill)`
  top: 10px;
  position: relative;
  float: left;
`;

const NotificationDiv = styled.div`
  flex: 1 1 0%;
  margin: 8px 10px 8px 0px;
  max-width: 100%;
  padding-left: 40px;
`;

const Title = styled.div`
  display: inline;
  padding-left: .3em;
  line-height: 18px;
  font-size: 14px;
`;

const Message = styled.div`
  padding-left: .3em;
  line-height: 18px;
  font-size: 10px;
  letter-spacing: -0.21px;
`;

const Content = styled(motion.div)<{ visibility?: boolean }>`
  border-radius:  ${({ theme }) => theme.toaster.radius};
  padding: 15px;
  min-width: 185px;
  white-space: pre-wrap;
  color: white;
  box-shadow: 0 15px 15px rgb(0 0 0 / 20%);

`;

const Container = styled.li`
list-style-type: none;
padding: 10px;
`;

const CloseButton = styled(UnstyledButton)`
  position: absolute;
  z-index: 2;
  right: 5px;
  top: 5px;
  &:hover{
    transform: scale(1.1);
  }
`;

const StyledCross = styled(Cross)`
  padding: 0.3rem;
  color: ${({ theme }) => theme.colors.white};
`;
